import Specialization from './find-specialization.vue'
export default Specialization